// Core
import styled from 'styled-components';

/*
  Styled component for the error indicator wrapper (to enable hover events)
*/
export const ErrorIndicatorWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  svg {
    width: 20px;
    height: 23px;
    color: ${({ theme }) => theme.color.thresholdErrorTooltip.iconColor};

    &:hover {
      color: ${({ theme }) => theme.color.thresholdErrorTooltip.iconHoverColor};
    };
  };
`;

/*
  Styled component for the tooltip portal container with fixed positioning
*/
export const TooltipPortalContainer = styled.div<{ top: number; left: number; visible: boolean }>`
  position: fixed;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  transform: translate(-50%, calc(-100% - 10px));
  z-index: 9999;
  pointer-events: none;
  transition: all 250ms;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;

/*
  Styled component for the tooltip content (reusing visual styles from Tooltip component)
*/
export const TooltipContentBox = styled.div`
  width: max-content;
  max-width: 235px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  background-color: ${({ theme }) => theme.color.thresholdErrorTooltip.backgroundColor};
  border-radius: 8px;
  box-shadow: 0 12px 16px -4px ${({ theme }) => theme.color.thresholdErrorTooltip.shadowColor},
              0px 4px 6px -2px ${({ theme }) => theme.color.thresholdErrorTooltip.shadowColor},
              12px 0 16px -4px ${({ theme }) => theme.color.thresholdErrorTooltip.shadowColor},
              -12px 0 16px -4px ${({ theme }) => theme.color.thresholdErrorTooltip.shadowColor};
  box-sizing: border-box;
  padding: 8px 12px;
  position: relative;

  /* Tooltip arrow pointing down */
  &:after {
    border-style: solid;
    border-width: 8px;
    content: '';
    position: absolute;
    border-color: ${({ theme }) => theme.color.thresholdErrorTooltip.arrowBackgroundColor} transparent transparent transparent;
    left: 50%;
    transform: translateX(-50%);
    top: 100%;
  };
`;
